export const capitalize = (str: string): string => {
   if (str) {
      return str.substring(0, 1).toUpperCase() + str.substring(1, str.length);
   }

   return '';
};

export const capitalizeWords = (str: string, separator: string = '_'): string => {
   if (!str) return '';
   return str.split(separator).map(capitalize).join(' ');
};

export async function copyToClipboard(text: string): Promise<void> {
   await navigator.clipboard.writeText(text);
}

export function highlightTextInElement(element: HTMLElement | null, text: string, highlightClassName: string): void {
   if (element) {
      const content = element.innerText;
      const contentLowerCase = content.toLowerCase();
      const searchLowerCase = text.toLowerCase();

      const indexOfSearch = contentLowerCase.indexOf(searchLowerCase);
      if (indexOfSearch !== -1) {
         const original = content.substring(indexOfSearch, indexOfSearch + searchLowerCase.length);

         element.innerHTML =
            content.substring(0, indexOfSearch) +
            `<span class="${highlightClassName}">${original}</span>` +
            content.substring(indexOfSearch + searchLowerCase.length);
      } else {
         element.innerHTML = content;
      }
   }
}

export function stripHtml(html: string): string {
   const div = document.createElement('div');
   div.innerHTML = html;
   return div.innerText;
}

export function stringToNumber(value: string): number {
   if (isNaN(parseInt(value))) {
      return 0;
   }

   return parseInt(value);
}

export function filterStringToArray(filterString: string): string[] {
   return filterString.split(';').map((filter) => filter.trim());
}
